import React, {Component} from 'react';
import {Button, Popover, PopoverHeader, PopoverBody, ListGroup, ListGroupItem, ListGroupItemHeading, ListGroupItemText} from 'reactstrap'
import {Query} from 'react-apollo'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import PropTypes from 'prop-types'

import QUERY from '../../../queries/server/dashboard_widgets'

export default class DashboardWidgetsSelector extends Component {

  state = {
    isOpen: false
  }

  toggle = () => {
    this.setState({isOpen: !this.state.isOpen})
  }

  render() {
    const {selectedWidgets, onChange} = this.props
    return (
      <Query query={QUERY} fetchPolicy="network-only">
        {({data, loading}) => {

          if(loading) return null

          return (
            <div>
              <Button id="widgets" color="info">
                <FontAwesomeIcon color="#fff" icon="cogs" />{' '}
                Select Widgets
              </Button>
              <Popover placement="left" target="widgets" isOpen={this.state.isOpen} toggle={this.toggle}>
                <PopoverHeader>Widgets</PopoverHeader>
                <PopoverBody style={{overflow: 'auto', height: '400px'}}>
                  <ListGroup>
                    {data.dashboard_widgets.map(({id, name, description, settings}) => {
                      const isSelected = selectedWidgets && selectedWidgets.some(selectedWidget => id === selectedWidget.id)
                      return (
                        <ListGroupItem tag="a" action onClick={() => onChange({id, name, description, settings}, !isSelected)}>
                          <ListGroupItemHeading>
                            <div className="d-flex flex-row align-items-center">
                              {isSelected && <FontAwesomeIcon icon="check-circle" style={{marginRight: '5px'}} />}
                              {name}
                            </div>
                          </ListGroupItemHeading>
                          <ListGroupItemText>
                            {description}
                          </ListGroupItemText>
                        </ListGroupItem>
                      )})}
                  </ListGroup>
                </PopoverBody>
              </Popover>
            </div>
          )
        }}
      </Query>
    )
  }
}

DashboardWidgetsSelector.propTypes = {
  selectedWidgets: PropTypes.array,
  onChange: PropTypes.func.isRequired,
}
